/* eslint-disable
    import/no-duplicates,
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import DashboardConstants from 'constants/DashboardConstants'
import InboxConstants from 'constants/InboxConstants'
import { captureException } from 'utils/SentryHelpers'
import { captureResponseException } from 'utils/SentryHelpers'

const InboxQueries = Marty.createQueries({
  id: 'InboxQueries',

  fetchInboxes() {
    const inboxesPromise = this.app.sources.InboxAPI.fetchInboxes()

    inboxesPromise.then(res => {
      if (res.status === 200) {
        return this.dispatch(InboxConstants.INBOX_LIST_FETCH_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(InboxConstants.INBOX_LIST_FETCH_FAILED, res)
      }
    })

    return inboxesPromise.catch(error => {
      return this.dispatch(InboxConstants.INBOX_LIST_FETCH_FAILED, error)
    })
  },

  fetchInbox(inboxId) {
    const inboxPromise = this.app.sources.InboxAPI.fetchInbox(inboxId)

    inboxPromise.then(res => {
      if (res.status === 200) {
        return this.dispatch(InboxConstants.INBOX_FETCH_DONE, inboxId, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(InboxConstants.INBOX_FETCH_FAILED, inboxId, res)
      }
    })

    return inboxPromise.catch(error => {
      captureException(error)
      return this.dispatch(InboxConstants.INBOX_FETCH_FAILED, inboxId, error)
    })
  },

  archiveInbox(inboxId) {
    const inboxPromise = this.app.sources.InboxAPI.archiveInbox(inboxId)

    inboxPromise.then(res => {
      if (res.status === 200) {
        return this.dispatch(InboxConstants.INBOX_ARCHIVE_DONE, inboxId)
      } else {
        captureResponseException(res)
        return this.dispatch(InboxConstants.INBOX_ARCHIVE_FAILED, inboxId)
      }
    })

    return inboxPromise.catch(error => {
      captureException(error)
      return this.dispatch(InboxConstants.INBOX_ARCHIVE_FAILED, inboxId, error)
    })
  },

  fetchInboxMetrics(inboxId, startDate, endDate) {
    const dashboardPromise = this.app.sources.InboxAPI.fetchInboxMetrics(inboxId, startDate, endDate)

    return dashboardPromise.then(res => {
      if (res.status === 200) {
        return this.dispatch(DashboardConstants.INBOX_FETCH_STATS_DONE, inboxId, startDate, endDate, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(DashboardConstants.INBOX_FETCH_STATS_FAILED, inboxId, startDate, endDate, res.body)
      }
    })
  },

  updateInbox(inboxId, params) {
    const updateInboxPromise = this.app.sources.InboxAPI.updateInbox(inboxId, params)
    updateInboxPromise.then(res => {
      if (res.status === 200) {
        this.dispatch(InboxConstants.INBOX_UPDATE_DONE, inboxId, res.body)
        return this.app.actions.NotificationActions.pushNotification({
          content: `Your ${ res.body.name } inbox has been updated!`
        })
      } else {
        captureResponseException(res)
        return this.dispatch(InboxConstants.INBOX_UPDATE_FAILED, inboxId, res)
      }
    })

    return updateInboxPromise.catch(error => {
      captureException(error)
      return this.dispatch(InboxConstants.INBOX_UPDATE_FAILED, inboxId, error)
    })
  },

  createInbox(params) {
    const createInboxPromise = this.app.sources.InboxAPI.createInbox(params)
    createInboxPromise.then(res => {
      if (res.status === 200) {
        this.dispatch(InboxConstants.INBOX_CREATE_DONE, res.body)
        return this.app.actions.NotificationActions.pushNotification({
          content: `${ res.body.name } has been created as a new inbox!`
        })
      } else {
        captureResponseException(res)
        return this.dispatch(InboxConstants.INBOX_CREATE_FAILED, res)
      }
    })

    return createInboxPromise.catch(error => {
      captureException(error)
      return this.dispatch(InboxConstants.INBOX_CREATE_FAILED, error)
    })
  },

  checkInboxExistsForEmail(email) {
    return this.app.sources.InboxAPI.checkInboxExistsForEmail(email).then(res => {
      if ((res.status === 200) && res.body.length) {
        return this.dispatch(InboxConstants.CHECK_INBOX_EXISTENCE_BY_EMAIL_DONE, email, true)
      } else if (res.body.length === 0) {
        return this.dispatch(InboxConstants.CHECK_INBOX_EXISTENCE_BY_EMAIL_DONE, email, false)
      } else {
        this.dispatch(InboxConstants.CHECK_INBOX_EXISTENCE_BY_EMAIL_FAILED, email, res)
        return captureResponseException(res)
      }

    }).catch(error => {
      captureException(error)
      return this.dispatch(CustomerConstants.CHECK_INBOX_EXISTENCE_BY_EMAIL_FAILED, email, orgHandle, error)
    })
  },

  createWhiteListLabels(domain) {
    const createWhiteListLabelsPromise = this.app.sources.InboxAPI.createWhiteLabelConfiguration(domain)
    return createWhiteListLabelsPromise.then(res => {
      if (res.status === 200) {
        return this.dispatch(InboxConstants.WHITE_LIST_LABELS_CREATE_DONE, domain, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(InboxConstants.WHITE_LIST_LABELS_CREATE_FAILED, res)
      }
    })
  },

  fetchWhiteListLabelsByDomain(domain) {
    return this.app.sources.InboxAPI.fetchWhiteListLabels(domain).then(res => {
      if (res.status === 200) {
        return this.dispatch(InboxConstants.WHITE_LIST_LABELS_FETCH_DONE, domain, res.body)
      } else if (res.status === 404) {
        return this.dispatch(InboxConstants.WHITE_LIST_LABELS_VALIDATE_DONE, domain, {})
      } else {
        captureResponseException(res)
        return this.dispatch(InboxConstants.WHITE_LIST_LABELS_FETCH_DONE, domain, {})
      }
    })
  },

  validateWhiteListLabels(domain) {
    return this.app.sources.InboxAPI.validateWhiteListLabels(domain).then(res => {
      if (res.status === 200) {
        return this.dispatch(InboxConstants.WHITE_LIST_LABELS_VALIDATE_DONE, domain, res.body)
      } else if (res.status === 404) {
        return this.dispatch(InboxConstants.WHITE_LIST_LABELS_VALIDATE_DONE, domain, {})
      } else {
        captureResponseException(res)
        return this.dispatch(InboxConstants.WHITE_LIST_LABELS_VALIDATE_FAILED, domain, {})
      }
    })
  }
})

export default InboxQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/InboxQueries.js